import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import Home from './pages/Home';
import RequireAuth from './components/RequireAuth';
import { Loader2 } from 'lucide-react';

const Callback    = lazy(() => import('./pages/Callback'));
const Jobs        = lazy(() => import('./pages/Jobs'));
const NewJob      = lazy(() => import('./pages/NewJob'));
const JobDetail   = lazy(() => import('./pages/JobDetail'));
const Master      = lazy(() => import('./pages/Master'));
const Collections      = lazy(() => import('./pages/Collections'));
const CollectionDetail = lazy(() => import('./pages/CollectionDetail'));
const CollectionNew    = lazy(() => import('./pages/CollectionNew'));

const Loading: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-space-950 text-white/50">
    <Loader2 className="h-5 w-5 animate-spin" />
  </div>
);

// BrowserRouter must wrap AuthProvider — AuthContext calls useNavigate() so
// the post-OAuth-callback redirect swaps the active route (not just the URL)
// and the <Callback> spinner unmounts cleanly.
const App: React.FC = () => (
  <HelmetProvider>
    <BrowserRouter>
      <AuthProvider>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/"          element={<Home />} />
            <Route path="/callback"  element={<Callback />} />
            <Route path="/jobs"        element={<RequireAuth><Jobs /></RequireAuth>} />
            <Route path="/jobs/new"    element={<RequireAuth><NewJob /></RequireAuth>} />
            <Route path="/jobs/:id"        element={<RequireAuth><JobDetail /></RequireAuth>} />
            <Route path="/jobs/:id/master" element={<RequireAuth><Master /></RequireAuth>} />
            <Route path="/collections"     element={<RequireAuth><Collections /></RequireAuth>} />
            <Route path="/collections/new" element={<RequireAuth><CollectionNew /></RequireAuth>} />
            <Route path="/collections/:id" element={<RequireAuth><CollectionDetail /></RequireAuth>} />
          </Routes>
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  </HelmetProvider>
);

export default App;
